import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";
import queryClient from "single-spa/react-app/query-client";

export const ACTIVATION_OBJECT_QUERY_KEY = "activation-object";

const useActivationObjectQuery = (objectId?: string, refetchOnMount = false, enabled = true) => {
    return useQuery<ShortActivationSetSchema>({
        queryKey: [ACTIVATION_OBJECT_QUERY_KEY, objectId],
        queryFn: async () => {
            const api = createActivationApi();

            return api.activation.getActivationById(objectId);
        },
        initialData: () => queryClient.getQueryData([ACTIVATION_OBJECT_QUERY_KEY, objectId]),
        initialDataUpdatedAt: queryClient.getQueryState([ACTIVATION_OBJECT_QUERY_KEY, objectId])?.dataUpdatedAt,
        throwOnError: true,
        placeholderData: keepPreviousData,
        refetchOnMount,
        enabled,
    });
};

export default useActivationObjectQuery;
